import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, tap } from 'rxjs/operators';
import { changeFileAction, changeFileSuccessAction, downloadFileAction } from './binary.actions';
import { BinaryService } from './binary.service';

@Injectable()
export class BinaryEffects {
	constructor(
		private actions: Actions,
		private service: BinaryService
	) {}

	changeFile = createEffect(() =>
		this.actions.pipe(
			ofType(changeFileAction),
			switchMap(({ resource, linkRel, fileType, file }) => {
				return this.service
					.changeFile(resource, linkRel, file)
					.pipe(map(response => changeFileSuccessAction({ fileType, file, report: response['body'] })));
			})
		)
	);

	download = createEffect(
		() =>
			this.actions.pipe(
				ofType(downloadFileAction),
				tap(({ binaryFile }) => this.service.downloadFile(binaryFile))
			),
		{ dispatch: false }
	);
}
